<template>
  <div>
    <!-- New Layout: After 1 Jan 2026 -->
    <b-table-simple
      v-if="isAfterCutoff"
      id="doctorSummaryReport"
      ref="doctorSummaryReport"
      hover
      small
      responsive
    >
      <b-thead head-variant="light">
        <b-tr class="text-right">
          <b-th class="text-left">รายการ</b-th>
          <b-th>แพทย์</b-th>
          <b-th v-if="reportSetting.cfVisible">คลินิก</b-th>
          <b-th v-if="reportSetting.cfVisible">รวม</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <!-- รายได้รวม (DF ก่อนหัก) -->
        <b-tr>
          <b-th>รายได้รวม (DF ก่อนหัก)</b-th>
          <b-td class="text-right">{{ formatNumber(dfByPaymentSummary.df) }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            formatNumber(total.paidCf)
          }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            formatNumber(total.paid)
          }}</b-td>
        </b-tr>

        <!-- ค่าธรรมเนียมการชำระ Header -->
        <b-tr v-if="summaryByPayment.length > 0" class="bg-light">
          <b-th colspan="4">ค่าธรรมเนียมการชำระ:</b-th>
        </b-tr>

        <!-- ค่าธรรมเนียมแยกตามวิธีชำระ -->
        <b-tr
          v-for="(item, index) in summaryByPayment"
          :key="index"
          class="text-muted"
        >
          <b-td class="pl-4">- {{ item.name }} ({{ item.feePercent }}%)</b-td>
          <b-td class="text-right text-danger">({{ formatNumber(item.feeAmount) }})</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right"></b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right"></b-td>
        </b-tr>

        <!-- รวมค่าธรรมเนียม -->
        <b-tr v-if="summaryByPayment.length > 0">
          <b-th class="pl-4">รวมค่าธรรมเนียม</b-th>
          <b-td class="text-right text-danger font-weight-bold">({{ formatNumber(dfByPaymentSummary.feeAmount) }})</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right"></b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right"></b-td>
        </b-tr>

        <!-- DF หลังหักค่าธรรมเนียม -->
        <b-tr class="table-info">
          <b-th>DF หลังหักค่าธรรมเนียม</b-th>
          <b-td class="text-right font-weight-bold">{{ formatNumber(dfByPaymentSummary.netDf) }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            formatNumber(total.paidCf)
          }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            formatNumber(dfByPaymentSummary.netDf + total.paidCf)
          }}</b-td>
        </b-tr>

        <!-- ค่าแลป -->
        <b-tr>
          <b-th>ค่าแลป</b-th>
          <b-td class="text-right text-danger">({{ formatNumber(total.labDf) }})</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right text-danger">({{
            formatNumber(total.labCf)
          }})</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right text-danger">({{
            formatNumber(total.labTotal)
          }})</b-td>
        </b-tr>

        <!-- หักค่าใช้จ่าย 10% -->
        <b-tr :class="isDeducted ? '' : 'text-muted'">
          <b-th>
            <b-form-checkbox
              v-model="isDeducted"
              @change="handleDeductChange"
              switch
            >
              หักค่าใช้จ่าย 10% ตามสัญญาแพทย์
            </b-form-checkbox>
          </b-th>
          <b-td class="text-right text-danger">{{ isDeducted ? '(' + formatNumber(deductDfNew) + ')' : '-' }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right"></b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right"></b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr variant="secondary" class="text-bold">
          <b-th>รายได้สุทธิ</b-th>
          <b-td class="text-right">{{
            formatNumber(dfByPaymentSummary.netDf - total.labDf - deductDfNew)
          }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            formatNumber(total.paidCf - total.labCf)
          }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            formatNumber(dfByPaymentSummary.netDf + total.paidCf - total.labTotal - deductDfNew)
          }}</b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>

    <!-- Old Layout: Before 1 Jan 2026 -->
    <b-table-simple
      v-else
      id="doctorSummaryReport"
      ref="doctorSummaryReport"
      hover
      small
      responsive
    >
      <b-thead head-variant="light">
        <b-tr class="text-right">
          <b-th></b-th>
          <b-th>แพทย์</b-th>
          <b-th v-if="reportSetting.cfVisible">คลินิก</b-th>
          <b-th v-if="reportSetting.cfVisible">รวม</b-th>
        </b-tr></b-thead
      >
      <b-tbody>
        <b-tr>
          <b-th>รายได้</b-th>
          <b-td class="text-right">{{ total.paidDf }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            total.paidCf
          }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            total.paid
          }}</b-td>
        </b-tr>
        <b-tr>
          <b-th>ค่าแลป</b-th>
          <b-td class="text-right">{{ total.labDf }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            total.labCf
          }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            total.labTotal
          }}</b-td>
        </b-tr>
        <b-tr :class="isDeducted ? '' : 'text-muted'">
          <b-th
            ><b-form-checkbox
              v-model="isDeducted"
              @change="handleDeductChange"
              switch
            >
              หักค่าใช้จ่าย 10% ตามสัญญาแพทย์</b-form-checkbox
            >
          </b-th>
          <b-td class="text-right">{{ deductDf }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right"></b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right"></b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr variant="secondary" class="text-bold">
          <b-th>รวม</b-th>
          <b-td class="text-right">{{
            total.paidDf - total.labDf - deductDf
          }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            total.paidCf - total.labCf
          }}</b-td>
          <b-td v-if="reportSetting.cfVisible" class="text-right">{{
            total.paid - total.labTotal
          }}</b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "dfSummaryTable",
  components: {},
  props: {
    total: {
      type: Object,
      default: () => ({
        paid: 0,
        paidDf: 0,
        paidCf: 0,
        labTotal: 0,
        labDf: 0,
        labCf: 0,
      }),
    },
    reportSetting: {
      type: Object,
      default: () => ({ cfVisible: false }),
    },
    dateRange: {
      type: Array,
      default: () => [],
    },
    dfByPaymentSummary: {
      type: Object,
      default: () => ({ df: 0, feeAmount: 0, netDf: 0 }),
    },
    summaryByPayment: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      percent: 10,
      isDeducted: false,
      cutoffDate: new Date("2026-02-01"), // 1 ก.พ. 69
    };
  },
  created() {},
  computed: {
    // Check if date range is after cutoff (1 Jan 2026)
    isAfterCutoff() {
      if (!this.dateRange || this.dateRange.length < 1) return false;
      const startDate = moment(this.dateRange[0]).startOf("day");
      return startDate.isSameOrAfter(moment(this.cutoffDate));
    },

    // Old calculation (before cutoff)
    deductDf() {
      return this.calculateDeduct(this.total.paidDf - this.total.labDf);
    },
    deductCf() {
      return this.calculateDeduct(this.total.paidCf - this.total.labCf);
    },
    deductTotal() {
      return this.calculateDeduct(this.total.paid - this.total.labTotal);
    },

    // New calculation (after cutoff)
    deductDfNew() {
      if (!this.isDeducted) return 0;
      const netAfterLab = this.dfByPaymentSummary.netDf - this.total.labDf;
      return this.toFixed2IfNecessary((netAfterLab * this.percent) / 100);
    },
  },
  watch: {},
  methods: {
    calculateDeduct(val) {
      if (!this.isDeducted) return 0;
      return this.toFixed2IfNecessary((val * this.percent) / 100);
    },
    toFixed2IfNecessary(value) {
      return +parseFloat(value).toFixed(2);
    },
    formatNumber(num) {
      if (num === null || num === undefined) return "-";
      return num.toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    handleDeductChange(e) {
      this.$emit("updateIsDeducted", this.isDeducted);
    },
  },

  async mounted() {
    this.isDeducted = Boolean(
      JSON.parse(localStorage.getItem("reportSetting") || "{}")?.isDeducted
    );
  },
  updated() {},
};
</script>

<style>
.sr-only {
  display: none;
}
</style>
